/* ACC_BN_LP_103 — Section 09: Comparison Table
   Below 420px the table scrolls horizontally (.acc103-09__table-scroll).
   These 3 dots indicate the scroll position — the pink dot moves left→right
   as the table is scrolled. (Dots are CSS-hidden ≥420px where it doesn't scroll.) */
(function () {
  'use strict';

  function init() {
    var scroller = document.querySelector('.acc103-09__table-scroll');
    var dotsWrap = document.querySelector('[data-acc103-09-dots]');
    if (!scroller || !dotsWrap) return;

    var dots = dotsWrap.querySelectorAll('.acc103-09__scroll-dot');
    if (!dots.length) return;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      // ratio 0 (fully left) → 1 (fully right); map onto the 3 dots
      var ratio = max > 0 ? scroller.scrollLeft / max : 0;
      var active = Math.round(ratio * (dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === active);
      }
    }

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', update);

    // Optional: clicking a dot scrolls the table to that position
    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          var max = scroller.scrollWidth - scroller.clientWidth;
          scroller.scrollTo({ left: (max * idx) / (dots.length - 1), behavior: 'smooth' });
        });
      })(i);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
